import { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

interface FeedbackModalProps {
  show: boolean;
  onHide: () => void;
  type: "success" | "error";
  message: string;
  autoClose?: boolean; // 👈 opcional
  duration?: number;   // 👈 duración en ms
}

export function FeedbackModal({
  show,
  onHide,
  type,
  message,
  autoClose = true,
  duration = 3000,
}: FeedbackModalProps) {
  const isSuccess = type === "success";

  useEffect(() => {
    if (show && autoClose) {
      const timer = setTimeout(() => {
        onHide();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, autoClose, duration, onHide]);

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton className={isSuccess ? "bg-success text-white" : "bg-danger text-white"}>
        <Modal.Title>{isSuccess ? "Éxito" : "Error"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant={isSuccess ? "light" : "outline-light"} onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}